// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assests/footerbg-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_main {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  background-size: cover;
  padding-top: 5rem;
  padding-bottom: 1rem;
  border-top: 2px solid #00000020;
}

.ftr_nav_items {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
}

.footer_nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  border-bottom: 1px solid #bbbbbb;
  padding-bottom: 3rem;
}

.footer-icons {
  display: flex;
  gap: 2rem;
}

.meduimIocnbox {
  height: 30px;
  width: 30px;
  background-color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meduimIocnbox:hover {
  background-color: #e84427;
}

.ftr_nav_items a {
  text-decoration: none;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
}

.footet-social-icons {
  color: #000;
}

.footet-social-icons:hover {
  color: #e84427;
}

.feedback-title-text {
  font-size: 22px;
  font-weight: 600;
}

.ftr-fdbk-ipt-bx {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}
.ftr-fdbk-ipt-bx > div {
  height: 50px;
}
.ftr-fdbk-ipt-bx > div:first-child input {
  background: transparent;
  border: none;
  outline: none;
  width: 280px;
  height: 100%;
  color: #717171;
  border-bottom: 2px solid black;
  font-size: 17px;
}
.ftr-fdbk-ipt-bx > div:first-child input::placeholder {
  color: #717171;
  font-size: 17px;
}

.feed-back-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
}

.copyright-para {
  font-size: 22px;
  color: #000;
  font-weight: 500;
  width: 414px;
}

.terms-para {
  font-size: 14px;
  font-weight: 400;
  color: #515151;
}
/* .feed-back-container > div {
  width: 720px;
} */

.nav-link.active {
  color: #e84427 !important;
}

a:hover {
  color: #e84427 !important;
}

.footernav_items:hover {
  cursor: pointer;
}

.hreftext {
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  color: #515151;
}

@media screen and (max-width: 600px) {
  .ftr-fdbk-ipt-bx > div:first-child {
    width: 50% !important;
  }
  .ftr-fdbk-ipt-bx > div:last-child {
    width: 38% !important;
  }

  .feed-back-container > p {
    width: 95%;
    font-size: 16px;
  }
  .feed-back-container > div {
    width: 100%;
  }

  .footer_nav {
    padding-left: 12px;
    justify-content: center;
    align-items: flex-start;
  }

  .ftr_nav_items {
    justify-content: space-between;
    gap: 2rem;
    flex-grow: 1;
  }
  .feedback-title-text {
    font-size: 18px;
  }
}

@media screen and (max-width: 570px) {
  .ftr-fdbk-ipt-bx > div:first-child input {
    width: 100%;
    border-bottom: 2px solid black;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,yDAAyD;EACzD,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".footer_main {\n  background-image: url(\"../../assests/footerbg-image.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 100%;\n  background-size: cover;\n  padding-top: 5rem;\n  padding-bottom: 1rem;\n  border-top: 2px solid #00000020;\n}\n\n.ftr_nav_items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem;\n}\n\n.footer_nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2rem;\n  border-bottom: 1px solid #bbbbbb;\n  padding-bottom: 3rem;\n}\n\n.footer-icons {\n  display: flex;\n  gap: 2rem;\n}\n\n.meduimIocnbox {\n  height: 30px;\n  width: 30px;\n  background-color: #000;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.meduimIocnbox:hover {\n  background-color: #e84427;\n}\n\n.ftr_nav_items a {\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 20px;\n  color: #000000;\n}\n\n.footet-social-icons {\n  color: #000;\n}\n\n.footet-social-icons:hover {\n  color: #e84427;\n}\n\n.feedback-title-text {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.ftr-fdbk-ipt-bx {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n.ftr-fdbk-ipt-bx > div {\n  height: 50px;\n}\n.ftr-fdbk-ipt-bx > div:first-child input {\n  background: transparent;\n  border: none;\n  outline: none;\n  width: 280px;\n  height: 100%;\n  color: #717171;\n  border-bottom: 2px solid black;\n  font-size: 17px;\n}\n.ftr-fdbk-ipt-bx > div:first-child input::placeholder {\n  color: #717171;\n  font-size: 17px;\n}\n\n.feed-back-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.copyright-para {\n  font-size: 22px;\n  color: #000;\n  font-weight: 500;\n  width: 414px;\n}\n\n.terms-para {\n  font-size: 14px;\n  font-weight: 400;\n  color: #515151;\n}\n/* .feed-back-container > div {\n  width: 720px;\n} */\n\n.nav-link.active {\n  color: #e84427 !important;\n}\n\na:hover {\n  color: #e84427 !important;\n}\n\n.footernav_items:hover {\n  cursor: pointer;\n}\n\n.hreftext {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400;\n  color: #515151;\n}\n\n@media screen and (max-width: 600px) {\n  .ftr-fdbk-ipt-bx > div:first-child {\n    width: 50% !important;\n  }\n  .ftr-fdbk-ipt-bx > div:last-child {\n    width: 38% !important;\n  }\n\n  .feed-back-container > p {\n    width: 95%;\n    font-size: 16px;\n  }\n  .feed-back-container > div {\n    width: 100%;\n  }\n\n  .footer_nav {\n    padding-left: 12px;\n    justify-content: center;\n    align-items: flex-start;\n  }\n\n  .ftr_nav_items {\n    justify-content: space-between;\n    gap: 2rem;\n    flex-grow: 1;\n  }\n  .feedback-title-text {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 570px) {\n  .ftr-fdbk-ipt-bx > div:first-child input {\n    width: 100%;\n    border-bottom: 2px solid black;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
